import { createContext, useContext } from 'react';

// Carries a settings row's "show this detail page" request up to the modal that can page to it.
// A row can sit outside such a modal — the Settings page, the song form — so the default is null
// and DetailsPill falls back to opening a dialog of its own.
const SettingDetailsContext = createContext(null);

export const useShowSettingDetails = () => useContext(SettingDetailsContext);

export default SettingDetailsContext;
